import { runtimeConfigKeys, RuntimeConfig } from './runtime-config'

declare global {
  interface Window {
    /** Set by /config.js, which index.html loads before the app */
    __DD_CONFIG__?: RuntimeConfig
  }
}

/**
 * This environment's settings, from /config.js. Octopus leaves the #{...} token of a variable that has no value for the
 * environment, so the app stops here rather than put tokens in URLs and API keys.
 */
function readRuntimeConfig(): RuntimeConfig {
  const runtimeConfig = window.__DD_CONFIG__
  if (!runtimeConfig) {
    throw new Error(
      `/config.js didn't load or didn't set window.__DD_CONFIG__, so the app has no settings`,
    )
  }
  for (const key of Object.keys(runtimeConfigKeys) as (keyof RuntimeConfig)[]) {
    const value = runtimeConfig[key]
    if (!value || typeof value !== 'string') {
      throw new Error(
        `/config.js has no ${key}. In development it comes from ${runtimeConfigKeys[key]} in the .env files.`,
      )
    }
    if (/#\{.*\}/.test(value)) {
      throw new Error(
        `${key} in /config.js is still the Octopus variable ${value}: give it a value for this environment, then redeploy`,
      )
    }
  }
  return runtimeConfig
}

/** The app's settings. Read them from here, not import.meta.env, which doesn't have the per-environment ones */
export default {
  // From .env, the same in every environment, so built in
  title: import.meta.env.VITE_TITLE,
  maintenanceMode: import.meta.env.VITE_MAINTENANCE_MODE === '1',
  // Per environment, from /config.js
  ...readRuntimeConfig(),
}
